module.exports = __webpack_public_path__ + "img/feature-5.30388d7d.png";